export default "__VITE_ASSET__BnCWHV44__"